import { Component, inject, input } from '@angular/core';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { IonIcon } from '@ionic/angular/standalone';

@Component({
  selector: 'app-nav-icon',
  templateUrl: './nav-icon.component.html',
  styleUrls: ['./nav-icon.component.scss'],
  imports: [RouterLinkActive, RouterLink, IonIcon],
})
export class NavIconComponent {
  private router = inject(Router);

  readonly icon = input.required<string | undefined>();
  readonly route = input.required<string | undefined>();
  readonly displayText = input('');
  readonly hasDisplayText = input(false);

  get isActive(): any {
    return this.router.url.includes(this.route() as string);
  }

  get link(): any {
    return `${this.route()}`;
  }
}
